import React from 'react';
import { TopoPattern } from './TopoPattern';
const brands = ['DAIKIN', 'MITSUBISHI', 'AURUS', 'DAIZUKI', 'DELLA', 'EVERWELL', 'TCL', 'MR. COOL'];
export function BrandStrip() {
  return <section className="py-12 bg-sapper-dark relative border-y border-sapper-olive/30 overflow-hidden" data-id="element-1">
      <TopoPattern opacity={0.05} data-id="element-2" />

      <div className="container mx-auto px-4 relative z-10 mb-8 text-center" data-id="element-3">
        <div className="font-mono text-xs text-sapper-gray tracking-[0.2em] uppercase" data-id="element-4">
          [ AUTHORIZED INSTALLER // CERTIFIED BRAND PARTNERS ]
        </div>
      </div>

      <div className="relative z-10 flex overflow-hidden" data-id="element-5">
        <div className="flex animate-infinite-scroll whitespace-nowrap" data-id="element-6">
          {/* Double the list for seamless loop */}
          {[...brands, ...brands, ...brands].map((brand, idx) => <div key={idx} className="flex-shrink-0 mx-8 sm:mx-16 font-condensed font-bold text-3xl sm:text-4xl text-sapper-white/30 hover:text-sapper-white transition-colors cursor-default" data-id="element-7">
              {brand}
            </div>)}
        </div>
      </div>
    </section>;
}